import type { WidgetEvent } from "../types";

// Distinct tenant event categories present in a set of events, in first-seen
// order. Used to render the category filter both on the Events tab and under
// any service that hosts events ("What's on").
export function collectEventCategories(
  events: WidgetEvent[],
): { id: string; name: string }[] {
  const seen = new Map<string, string>();
  for (const e of events) {
    if (e.category_id && e.category_name && !seen.has(e.category_id)) {
      seen.set(e.category_id, e.category_name);
    }
  }
  return [...seen].map(([id, name]) => ({ id, name }));
}
